import {
    AlertDialog,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
  } from '@PorkyCol/alert-dialog';
  import { Autocomplete } from '@PorkyCol/autocomplete';
  import { Button } from '@PorkyCol/button';
  import { Stack } from '@mui/material';
  import { Checkbox } from '@PorkyCol/checkbox';
  import FormProvider from '@/commons/hook-form';
  import { Controller } from 'react-hook-form';
import { EmailList } from '../email-list';
import { useGenerateElectronicBill } from '../../hooks/useGenerateElectronicBill';
  
  export type GenerateElectornicBillForm = {
    customer_id?: string;
    isConsumer?: boolean;
    email_cc_list?: string[];
  };
  
  export const GenerateElectornicBill = ({ orderId }: { orderId: string}) => {
    const {
      customerOptions,
      showAlert,
      handlerCloseAlert,
      handlerCreateOption,
      handlerGenerateBill,
      handlerOnChange,
      handlerOptionClick,
      inputValue,
      isConsumer,
      methods,
      modal,
      onSubmit,
    } = useGenerateElectronicBill(orderId);
    
  
    return (
      <Stack marginLeft={2} position="relative">
        <Button className="ml-1" onClick={handlerGenerateBill}>
          Generar factura electrónica
        </Button>
        <AlertDialog className="" show={showAlert}>
          <FormProvider methods={methods} onSubmit={methods.handleSubmit(onSubmit)}>
            <AlertDialogHeader className="text-black font-bold">Generar Factura</AlertDialogHeader>
            <AlertDialogBody>
              <Controller
                name="isConsumer"
                control={methods.control}
                render={({ field }) => <Checkbox {...field}>Consumidor final</Checkbox>}
              />
              <p className='ml-3'>Número de cedula del cliente</p>
              <Autocomplete
                name="customer_id"
                hasNextData={false}
                options={customerOptions}
                onChange={handlerOnChange}
                onCreateOption={handlerCreateOption}
                handleOptionClick={handlerOptionClick}
                value={inputValue}
                disabled={isConsumer}
              />
              <EmailList unregister={methods.unregister} />
            </AlertDialogBody>
            <AlertDialogFooter className="flex flex-col gap-3">
              <Button
                color="primary"
                type="submit"
                variant="solid"
              >
                Generar
              </Button>
              <Button
                type="button"
                variant="solid"
                onClick={handlerCloseAlert}
                className="bg-primary-900 border-primary-900 hover:bg-primary-700 text-white rounded m-0"
              >
                Cancelar
              </Button>
            </AlertDialogFooter>
          </FormProvider>
        </AlertDialog>
        {modal}
      </Stack>
    );
  };
  